export default __webpack_public_path__ + "static/media/night-forest.0b0e154e.mp3";